import getSiteTemplateSlug from './site-template-slug';
import getSiteProperties from './site-properties';

const getConceptOrBuildSlug = (rootState) => {
  const properties = getSiteProperties(rootState);

  return properties.conceptSlug || getSiteTemplateSlug(rootState);
};

export default getConceptOrBuildSlug;
